import { render, staticRenderFns } from "./Incomings.vue?vue&type=template&id=24541950"
import script from "./Incomings.vue?vue&type=script&lang=js"
export * from "./Incomings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports